import React, { useState } from "react";
import Box, { BoxProps } from "@mui/material/Box";
import { EmtTextField } from "./EmtTextField";
import { SxProps } from "@mui/material/styles";

export type EmtDateRangePickerProps = Omit<BoxProps, "onChange" | "sx"> & {
  /**
   * Start Date label
   * @requires
   */
  startDateLabel: string;
  /**
   * Start date value
   * @default ""
   */
  startDateValue?: string;
  sx?: SxProps;
  /**
   * End Date label
   * @requires
   */
  endDateLabel: string;
  /**
   * End date value
   * @default ""
   */
  endDateValue?: string;
  /**
   * Send {start, end} value as string
   * @default undefined
   */
  onChange?: (start: string | undefined, end: string | undefined) => void;

  nonce?: string;
  onResizeCapture?: any;
  onResize?: any;
};

export const EmtDateRangePicker = React.forwardRef<
  HTMLDivElement,
  EmtDateRangePickerProps
>((props, ref) => {
  const {
    startDateLabel,
    endDateLabel,
    startDateValue = "",
    endDateValue = "",
    onChange,
    sx,
    ...rest
  } = props;
  const [dates, setDates] = useState<{
    start: string | undefined;
    end: string | undefined;
  }>();

  const handleChange = (start: string | undefined, end: string | undefined) => {
    setDates({ start, end });
    onChange ? onChange(start, end) : null;
  };

  return (
    <Box
      {...rest}
      ref={ref}
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "10px",
        ...sx,
      }}
    >
      <EmtTextField
        type="date"
        label={startDateLabel}
        onChange={(e) => handleChange(e.target.value, dates?.end)}
        value={startDateValue}
      />
      <EmtTextField
        type="date"
        label={endDateLabel}
        onChange={(e) => handleChange(dates?.start, e.target.value)}
        value={endDateValue}
      />
    </Box>
  );
});

EmtDateRangePicker.displayName = "EmtDateRangePicker";
